export default __webpack_public_path__ + "static/飞书20210914-143446-3e8fdb58e3f183ab9f905c3ec35bdeaf.png";